(ns frontend.ui.component.lp-portal.report.body.innovestor.holding.pdf
  (:require
   [common.util :as cu]
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.component.block-table.pdf-view :as block-table-pdf]
   [frontend.ui.component.lp-portal.report.component.vertical-table.pdf-view :as vertical-table-pdf]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.voima-components.pdf.column.view :as column]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
   [frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.fund-overview :refer 
    [empty-chart-data?]]
   [potpuri.core :as potpuri]))

(defn image
  [data]
  (when-not (cu/blank-value? (:image data))
    (card/card
     ""
     {:image (str (:image data))
      :width 200}
     (text-content/optional-footer data))))

(defn company-page
  [data]
  (let [{:keys [holding-name company-information investment-information status-and-events exit-strategy holding-image]}
        data]
    (page/page
     (page/page-title-with-line {:fund-name  (:fund-name data)
                                 :page-title
                                 holding-name
                                 :toc-item   true
                                 :reporting-period (:reporting-period data)})
     (column/half-columns
      (card/card ""
                 (card/table-card ""
                                  (block-table-pdf/table company-information))
                 (card/card ""
                            (text-content/rich-content (->> status-and-events
                                                            :rich-content))))
      (card/card ""
                 (card/table-card ""
                                  (block-table-pdf/table investment-information))
                 (card/card ""
                            (text-content/rich-content (->> exit-strategy
                                                            :rich-content)))))
     (image holding-image))))

(defn financial-performance-chart
  [data]
  (let [figures (-> data
                    :financial-performance-chart
                    :figures)]
    (when-not (empty-chart-data? data :financial-performance-chart)
      [(card/card
        "Financial performance"
        {:svg    (chart-view/chart-svg "highcharts"
                                       (potpuri/deep-merge figures
                                                           {:chart {:width     400
                                                                    :height    300
                                                                    :spacing   [10 50 50 0]
                                                                    :marginTop 20}
                                                            :legend {:verticalAlign "top"
                                                                     :align         "center"
                                                                     :floating      true
                                                                     :padding       0}
                                                            :plotOptions {:series {:dataLabels   {:enabled true
                                                                                                  :style   {:color       "grey"
                                                                                                            :textOutline false}}}}}))
         :width  200
         :height 150})])))

(defn tech-company-page
  [data]
  (let [{:keys [holding-name company-information investment-information status-and-events financial-performance-table]}
        data]
    (page/page
     (page/page-title-with-line {:fund-name  (:fund-name data)
                                 :page-title
                                 holding-name
                                 :toc-item   true
                                 :reporting-period (:reporting-period data)})
     (column/half-columns
      (card/card ""
                 (card/table-card ""
                                  (block-table-pdf/table company-information))
                 (financial-performance-chart data)
                 (vertical-table-pdf/table financial-performance-table)
                 (text-content/optional-footer financial-performance-table))
      (card/card ""
                 (card/table-card ""
                                  (block-table-pdf/table investment-information))
                 (card/card ""
                            (text-content/rich-content (->> status-and-events
                                                            :rich-content))))))))

(defn holding-pages
  [data]
  (when-not (cu/blank-value? (:reference-date data))
    (concat [(company-page data)])))

(defn tech-holding-pages
  [data]
  (when-not (cu/blank-value? (:reference-date data))
    (concat [(tech-company-page data)])))
